import request from '../utils/request';
const querystring = require('querystring')
 
//获取列表数据
export const fetchData = query => {  
    
    var list = request({
        url: 'comOrderPush/selectPage.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
 
//启用-禁用 
export const changeStatus = query => {  
    var list = request({
        url: 'comOrderPush/changeStatus.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
//添加渠道信息
export const saveForm = query => {  
    var list = request({
        url: 'comOrderPush/insert.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const handDelete = query => {  
    var list = request({
        url: 'comOrderPush/delete.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const update = query => {  
    var list = request({
        url: 'comOrderPush/update.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const updateMore = query => {  
    var list = request({
        url: 'comOrderPush/updateMore.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const fetchSelect = query => {  
    var list = request({
        url: 'comOrderPush/getListFetch.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const getOrderDetail = query => {  
    var list = request({
        url: 'comOrderPushDetail/getData.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const getOrderStep = query => {  
    var list = request({
        url: 'comOrderPushStep/getList.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const getOrderBack = query => {  
    var list = request({
        url: 'comOrderPushBack/getList.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const changeStatusMore = query => {  
    var list = request({
        url: 'comOrderPush/changeStatusMore.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const downOrderExcel = query => {  
    var list = request({
        url: 'comOrderPush/getOrderExcel.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};


export const backSys = query => {  
    var list = request({
        url: 'comOrderPush/updateByBackSys.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const changePush = query => {  
    var list = request({
        url: 'comOrderPush/changePush.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const qyPush = query => {
    var list = request({
        url: 'comOrderPush/qyPush.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};


export const getOrderDiff = query => {  
    var list = request({
        url: 'comOrderPush/getOrderDiff.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const setResultToTM = query => {  
    var list = request({
        url: 'comOrderPush/setResultToTM.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const pushMem = query => {  
    var list = request({
        url: 'comOrderPush/updateByPushMem.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};